export const environment = {
  production: true,
  proxy: false,
};
